let regForm = document.querySelector(".registration-form");
regForm.addEventListener("submit", (event) => {
  event.preventDefault();
  if (typeof allValid !== "undefined" && allValid()) {
    const formData = new FormData(event.target);
    let options = {
      method: "POST",
      body: formData,
    };
    fetch("scripts/register.php", options).then((response) => {
      return response.json();
    }).then((text) => {
      if (text.userId === null && text.duplicateEmail) {
        document.getElementById("duplicate-email").classList.add("alert-msg--show");
      } else if (text.userId === null && !text.duplicateEmail) {
        document.getElementById("something-went-wrong").classList.add("alert-msg--show");
      } else if (text.userId !== null && !text.duplicateEmail) {
        let getUrl = window.location;
        regForm.reset();
        window.location.replace(getUrl.protocol + "//" + getUrl.host + "?message=0");
      }
    }).catch((error) => {
      console.error(error);
    })
  } else {
    document.getElementById("something-went-wrong").classList.add("alert-msg--show");
  }
});